var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckboxGen = function SvgIconCheckboxGen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-checkbox-gen_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F8DFD8",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    fillRule: "evenodd",
    d: "M14.797 6.548c.42.42.42 1.102 0 1.522l-5.382 5.382c-.42.42-1.101.42-1.522 0l-2.69-2.69a1.076 1.076 0 0 1 1.522-1.523l1.93 1.93 4.62-4.62c.42-.421 1.102-.421 1.522 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-checkbox-gen_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 5
  })))));
};
export default SvgIconCheckboxGen;